export default __webpack_public_path__ + "static/media/WaterBill.1a2e2f6f.pdf";